// NFCPlayerView.js
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const NFCPlayerView = ({ song }) => {
    if (!song) return null;

    return (
        <div className="card text-center shadow mt-4 p-3" style={{ maxWidth: '400px', margin: '0 auto' }}>
            <img src={song.imageUrl} className="card-img-top" alt={song.title} style={{ borderRadius: '10px' }} />
            <div className="card-body">
                <h5 className="card-title">{song.title}</h5>
                <p className="card-text text-muted">{song.artist}</p>

                {song.preview_url ? (
                    <audio controls src={song.preview_url} className="w-100 mt-2">
                        Tu navegador no soporta la reproducción de audio.
                    </audio>
                ) : (
                    <div className="text-muted mt-2">
                        <i className="bi bi-volume-mute"></i> No hay preview de audio disponible.
                    </div>
                )}

                <a href={song.url} className="btn btn-outline-primary mt-3" target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-spotify"></i> Abrir en Spotify
                </a>
            </div>
        </div>
    );
};

export default NFCPlayerView;
